module.exports = __webpack_public_path__ + "resources/img/bg_cover_customer_m.baf87d2c8f2dbd5e271e95be53a0f8c4.png";